import { ContentsCategories } from '@vestiaire/api-sdk-angular';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';
import { LocaleService } from '@app/core/i18n';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@env/environment';
import { Inject, PLATFORM_ID, Injectable } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { RoutingService } from '@app/core/services/routing.service';
import { cmsPageEditoUrlMatcher, cmsPageLandingUrlMatcher } from '@app/routes-matchers';
import { SessionCookieService } from '@app/core/cookies';

@Injectable({ providedIn: 'root' })
export class CmsResolver implements Resolve<any> {
  public constructor(
    private sessionService: SessionCookieService,
    private localService: LocaleService,
    public httpClient: HttpClient,
    private routingService: RoutingService,
    @Inject('SERVER_TIMEZONE') private timezone: string,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ContentsCategories> {
    const headers = this.getHeaders();
    const path = this.getPath(route);

    return <Observable<ContentsCategories>>this.httpClient.get(path, { headers }).pipe(
      map((res: any) => res.data),
      catchError((err: HttpErrorResponse) => {
        // @todo redirect to / when we have fallback home page
        this.routingService.redirectTo('/new-items/');
        return EMPTY;
      })
    );
  }

  getHeaders() {
    return {
      'x-country': this.localService.getCountry().toUpperCase(),
      'x-device-brand': 'other',
      'x-device-type': 'desktop',
      'x-lang-code': this.getFormatedLangCode(),
      'x-vc-timezone': isPlatformServer(this.platformId) && this.timezone ? this.timezone : '',
      'x-support-type': 'web',
      'x-vc-currency': this.localService.getCurrency(),
      'x-vc-language': this.localService.getLanguage(),
      'x-vc-siteid': this.localService.getSiteId(),
      'x-consumer-custom-id': this.sessionService.hasSession() ? this.sessionService.getUserId() : ''
    };
  }

  getFormatedLangCode(): string {
    const langCode = this.localService.getLocale();

    if (langCode.getRegion() === 'GB') {
      return `${langCode.getLanguage().toLowerCase()}_uk`;
    }
    return `${langCode.getLanguage().toLowerCase()}_${langCode.getRegion().toLowerCase()}`;
  }

  getPath(route: ActivatedRouteSnapshot): string {
    if (cmsPageLandingUrlMatcher(route.url)) {
      return `${environment.vccmsuri}/pages/url/${route.url[1].path}`;
    } else if (cmsPageEditoUrlMatcher(route.url)) {
      return `${environment.vccmsuri}/editos/url/${route.url[1].path}`;
    } else {
      return `${environment.vccmsuri}/pages/type/home`;
    }
  }
}
